import React, { Component } from 'react';
import APIHandler from './../utilities/apiHandler.js';
import cam from './../assets/img/cam.png';
import errorImg from './../assets/img/error.png';
import successImg from './../assets/img/success.png';
import ErrorBox from './ErrorBox.js';

export default class ImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            uploading: false,
            uploadStatus: null,
            error: false,
        };
        this.closeError = this.closeError.bind(this);
    }

    setUploadStatus(isSuccess, message) {
        this.setState({
            uploading: false,
        });
        var status;
        if (isSuccess) {
            status = {
                title: 'File uploaded successfully.',
                statusCss: 'success-text',
                icon: successImg,
                message: [message],
            };
        } else {
            if (!message) {
                status = {
                    title: 'File upload cancelled!',
                    statusCss: 'failure-text',
                    icon: errorImg,
                    message: ['Cancelled by user.'],
                };
            } else {
                status = {
                    title: 'Error uploading file',
                    statusCss: 'failure-text',
                    icon: errorImg,
                    message: message.error,
                };
            }
        }
        this.setState({
            uploadStatus: status,
        });
    }

    onDrop = (e) => {
        var file = e.target.files[0];
        if (file) {
            this.setState({
                file: file,
                uploading: true,
            });
        }
        var URL = this.props.url;
        var formData = new FormData();
        formData.append('file', file);
        APIHandler.postIngestion(URL, formData)
            .then(
                function (data) {
                    this.setUploadStatus(true, data);
                    if (this.props.handleUploadResponse) {
                        this.props.handleUploadResponse(data, this.props.type);
                    }
                }.bind(this)
            )
            .catch(
                function (error) {
                    this.setUploadStatus(false, error.error);
                    this.setState({ error: true });
                }.bind(this)
            )
            .finally(function (evt) {});
    };

    closeError() {
        this.setState({
            error: false,
        });
    }

    render() {
        const { file, uploading, uploadStatus } = this.state;
        let captureOnly = this.props.captureOnly ? true : false;
        return (
            <div>
                {this.state.error ? (
                    <ErrorBox
                        errorText={'Something went wrong while uploading image'}
                        closeError={this.closeError}
                    />
                ) : null}
                {!uploading ? (
                    <div
                        className="hidden-upload"
                        style={{ background: 'url(' + cam + ') center' }}
                    >
                        <input
                            type="file"
                            accept="image/*;capture=camera"
                            onChange={this.onDrop}
                            className="fileupload-form-0"
                            capture={captureOnly}
                        />
                    </div>
                ) : null}
                {file && !uploadStatus ? (
                    <div
                        style={{
                            textAlign: 'center',
                            paddingTop: '20px',
                            height: '150px',
                        }}
                    >
                        {uploading ? (
                            <div>
                                Uploading...
                                <br />
                                <small className="text-muted">
                                    {file.name}
                                </small>
                                <br />
                                <a href="" ng-click="cancel()">
                                    Cancel
                                </a>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/commons/ImageUploader.js